<template>
  <div id="dashboard" class="dashboard-table">
    <v-container fluid class="pt-0" style="padding-top: 20px !important; padding-bottom: 32px !important;">
      <Stats />
      
      <!-- FILTERS -->
      <div class="row">
        <div class="col-md-12">
          <div class='band'>
            <div class='controls'>
              <v-text-field
                style="max-width: 300px;"
                v-model="tableData.search"
                class="v-text-field--like glass w-search remove-underline search"
                prepend-inner-icon='search'
                @input="seaching"
                label="Search for previous submission..."
                placeholder="Start typing to search submissions"
                single-line
                solo
                hide-details
                dense
                clearable
                @click:clear="tableData.search = ''; getData()"
              ></v-text-field>

              <!-- <v-autocomplete
                class='glass w-sm dropdowns'
                flat
                hide-details
                v-model="tableData.length"
                @change="getData()"
                :items="perPage"
                solo
                :placeholder="tableData.length.toString()"
                label="Per Page"
              ></v-autocomplete> -->

              <v-autocomplete
                style="max-width: 300px;"
                class='glass w-md dropdowns'
                flat
                hide-details
                v-model="tableData.status"
                item-text="name"
                item-value="name"
                @change="getData()"
                clearable
                :items="statuses"
                solo
                placeholder="Filter by Status"
                label="Status"
              ></v-autocomplete>

              <v-btn
                v-if="tableData.search"
                class="glass-btn"
                small
                @click="clearFilters"
              >
                Clear
                <v-icon right small>mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- TABLE -->
      <div class='wrap'>
        <v-card class='table-card'>
          <v-progress-linear
            :indeterminate="processBar"
            height="2"
            class="my-0"
          ></v-progress-linear>

          <v-data-table
            :items="submissions"
            :headers="headers"
            :expand="false"
            :hide-actions="true"
            disable-initial-sort
            :pagination.sync="pagination"
            item-key="id"
            class="dashboard-data-table"
          >
            <template v-slot:items="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ formatDate(props.item.created_at, 'MM/DD/YYYY hh:mm') }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.company && props.item.company.company_name }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.company && props.item.company.company_dba }}</td>
                <td class="text-truncate" style="max-width:250px;">{{ props.item.contract_MID }}</td>
                <td class="text-truncate" style="max-width:125px; text-align: center;">
                  <div :class="check_status(props.item.deal_status)">{{ props.item.deal_status }}</div>
                </td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? (props.item.deal_lenders_with_offer_sent[0].lender_offer_amount) : ''  | currency}}</td>
                <td>{{ props.item.deal_sell_rate }}</td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? props.item.deal_lenders_with_offer_sent[0].lender_commission_amt : ''  | currency}}</td>
                <td>{{ props.item.deal_lenders_with_offer_sent.length>0 ? props.item.deal_lenders_with_offer_sent[0].lender_payment : ''  | currency}}</td>
                <td>{{ formatDate(props.item.updated_at, 'MM/DD/YYYY hh:mm') }}</td>
              </tr>
            </template>

            <template v-slot:expand="props">
              <v-card flat style="background-color: #f1f2f5;">
                <v-card-text class="py-2">
                  <table class="table table-striped mb-0" v-for="(items, index) in props.item.deal_lenders_with_offer_sent" :key="index">
                    <tr>
                      <th>Offer Amount: {{items.lender_offer_amount | currency}}</th>
                      <th>Payback Amount: {{items.lender_payback_amount | currency}}</th>
                      <th>Payment: {{items.lender_payment | currency}}, {{items.lender_payment_type}}</th>
                      <th>Factor Rate: {{items.lender_factor_rate}}</th>
                    </tr>
                    <tr>
                      <th>Buy Rate: {{items.lender_buy_rate}}</th>
                      <th>Commission Percentage: {{items.lender_commission_percentage}}</th>
                      <th>Term(days): {{items.lender_term}}</th>
                      <th>Position: {{items.lender_position_number}}</th>
                    </tr>
                    <tr>
                      <th>Fee Split: {{props.item.fee_split_percent}}</th>
                      <th>Lender Name: {{items.lender!=null ? items.lender.lender_name : ''}}</th>
                      <th>Tier: {{items.tier}}</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th colspan="2">Offer Status: {{items.lender_offer_status}}</th>
                    </tr>
                    <tr>
                      <th>
                        ISO Notification Message:
                        <span>{{items.offer_notify_note}}</span>
                      </th>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </template>

            <template slot="no-data">
              <p>No submissions found</p>
            </template>
          </v-data-table>

          <v-footer style="height: 48px;">
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="next"
            ></v-pagination>
          </v-footer>
        </v-card>
      </div>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import _ from 'lodash'
import axios from  'axios'
import {URL} from '../../env'
import Stats from './KPI/Stats.vue'

// import PreviewDialog from '../../Dashboard/Executive/PreviewDialog'

export default {
  // mixins: [UserHelper],
  components: {
    Stats,
    // PreviewDialog,
  },
  // props: {
  //   tableData: {
  //     type: Object,
  //     default: {}
  //   }
  // },
  data() {
    return {
      statuses: [],
      btn_loader: false,
      processBar: false,
      funded_status: false,
      pagination: { sortBy: "created_at", descending: true, rowsPerPage: -1 },
      page: 1,
      pages: 0,
      previewDialog: false,
      selectedDeal: null,
      submissions: [],
      perPage: [5, 10, 25, 50],
      tableData: {
        page: 1,
        length: 10,
        search: ""
      },
      headers: [
        {
          text: "Created",
          value: "created_at",
          align: "left"
        },
        {
          text: "Company Name",
          value: "company_name",
          align: "left"
        },
  
        {
          text: "DBA",
          value: "company_dba",
          align: "left"
        },
        {
          text: "MID",
          value: "contract_MID",
          align: "left"
        },
        {
          text: "Status",
          value: "deal_status",
          align: "left"
        },
        {
          text: "Offer Amount",
          value: "lender_offer_amount",
          align: "left"
        },
        {
          text: "Factor Rate",
          value: "deal_sell_rate",
          align: "left"
        },
        {
          text: "Commission",
          value: "lender_commission_amt",
          align: "left"
        },
        {
          text: "Payment",
          value: "lender_payment",
          align: "left"
        },
        {
          text: "Last Updated",
          value: "updated_at",
          align: "left"
        },
        // {
        //   text: "ISO Reps",
        //   value: "agent_name"
        // },
      ],
    };
  },
  mounted() {
    this.getData();
    this.getDealStatuses();
  },
  computed: {
    user_id() {
      return localStorage.getItem("user_id");
    },
    iso_id() {
      return localStorage.getItem("iso_id");
    }
  },
  // computed: {
  //   ...mapGetters({
  //     submissions: "deals/custom_report_subs"
  //   })
  // },
  methods: {
    // ...mapActions({
    //   getCustomReportSubmissions: "deals/getCustomReportSubmissions"
    // }),

    getDealStatuses() {
      axios.get(`${URL}/api/deal-status/deal-statuses`)
        .then(res => {
          this.statuses = res.data.data;
        }).catch(err => {
          console.error("Error fetching deal statuses:", err);
        });
    },
    
    async downloadExcelReport(){
      // this.btn_loader = true
      // await this.$store.dispatch('deals/downloadCustomReportSubmissions',
      //   Object.assign(this.tableData, { page: this.page, export_excel: 'DOWNLOAD'})
      // ).then(res=>{
      //   this.btn_loader = false
      // })
    },
    formatDate(date,type) {
      return moment(date).format(type);
    },
    // getPreviewDialog(item) {
    //   this.selectedDeal = item;
    //   this.previewDialog = true;
    // },
    redirectToSubPage({ unique_id, id }) {
      let route = this.$router.resolve({
        path: `submission/${unique_id}`,
        query: { companyId: id }
      });
      window.open(route.href, "_blank");
    },
    async seaching(){
      this.processBar = true
      await this.getSearchSubmission()
    },
    getSearchSubmission: _.debounce(function(e) {
      this.page = 1;
      this.getData();
    }, 3000),
    next(e) {
      this.page = e;
      this.getData();
    },
    getData() {
      this.processBar = true
      axios.get(`${URL}/api/submission/isoportal_subs`,{
        params: Object.assign(this.tableData, { page: this.page, export_excel: null, user_id: this.user_id, iso_id: this.iso_id })
      }
        )
        .then(res => {
          this.submissions = res.data.data
          this.processBar = false
          this.funded_status = this.tableData.status == "Funded" ? true : false;
          this.page = Math.ceil(res.data.to / this.tableData.length);
          this.pages = Math.ceil(res.data.total / this.tableData.length);
        }).catch(err=>{
          this.processBar = false
        });
    },
    closePreviewDialog() {
      this.previewDialog = false;
    },
    clearFilters(){
      this.tableData = {
        page: 1,
        length: 10,
        search: ""
      }
      this.getData()
    },
    check_status(s) {
      if (s == "Offer Sent") {
        return "offer_sent";
      } else if (s == "requested_information_file_upload") {
        return "requested";
      } else if (s == "Declined" || s == "Double Decline Submission") {
        return "decline";
      } else if (s == 1) {
        return "double_sub";
      }
    }
  }
};
</script>

<style scoped>
.dashboard-table{
    --ink:#0e1620; --muted:#6b7b8f; --line:#e6eef6; --accent:#67c1ee;
    --blue2:#f7fbff; --chip-blue:#d7e6ff; --chip-green:#d9f5df;
    --chip-red:#ffd7d7; --chip-pink:#ffddea; --chip-amber:#ffe8b7;
}
#dashboard >>> .v-datatable thead th{background:linear-gradient(180deg,#f6faff,#eef5ff)!important;color:#3b4e66!important;font-weight:600;border-bottom:1px solid var(--line)!important;text-align:left!important}
#dashboard >>> .v-datatable tbody td{border-bottom:1px solid #f1f5fb;text-align:left!important}
#dashboard >>> .v-datatable tbody tr:nth-child(even) td{background:#fcfeff}
#dashboard >>> .v-datatable tbody tr:hover td{background:#f8fbff}
#dashboard >>> table.v-table thead tr:first-child {
  height: 56px !important;
}
#dashboard >>> .v-datatable tbody tr {
  /* height: 21px !important; */
}
#dashboard >>> .v-datatable__expand-row--expanded {
  display: table-row !important;
}
#dashboard >>> .v-datatable__expand-row--expanded td {
  border-bottom: 1px solid #f1f5fb !important;
}
#dashboard >>> .glass.v-text-field > .v-input__control > .v-input__slot,
#dashboard >>> .glass.v-select     > .v-input__control > .v-input__slot{
    background:linear-gradient(180deg,#fff,#f6f9ff);
    border:1px solid #dbe6f3;border-radius:10px;min-height:34px;
    box-shadow:inset 0 1px 0 rgba(255,255,255,.9),0 6px 14px rgba(15,40,78,.06)
}
#dashboard >>> .glass.input-group--focused .v-input__slot{
    border-color:#67c1ee!important;box-shadow:0 0 0 2px rgba(103,193,238,.18),0 6px 14px rgba(15,40,78,.06)!important}
#dashboard >>> .glass .v-label{color:#8ea5bf!important}
#dashboard >>> .mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,"Courier New",monospace;font-size:12.5px}

.band{position:sticky;top:0;background:linear-gradient(180deg,#f7fbff,#eef5ff);border-bottom:1px solid var(--line);padding:12px 16px 10px;z-index:1}
.controls{display:flex;flex-wrap:wrap;gap:8px;align-items:center;max-width:1800px;margin:0 auto}

.w-search{min-width:340px;flex:3 1 420px}
.w-sm{width:130px}.w-md{width:170px}
.glass-btn{min-height:34px;border-radius:10px;border:1px solid #dbe6f3;text-transform:none;
    background:linear-gradient(180deg,#fff,#f6f9ff);box-shadow:inset 0 1px 0 rgba(255,255,255,.9),0 6px 14px rgba(15,40,78,.06)}
.wrap{margin:0 auto;}
.table-card{border:1px solid var(--line);overflow:hidden;background:#fff;
    box-shadow:0 20px 44px rgba(12,26,44,.08),inset 0 1px 0 rgba(255,255,255,.85)}
.chip-tight.v-chip{height:24px;line-height:24px;border-radius:999px;font-size:12px;border:1px solid rgba(16,24,40,.06);box-shadow:inset 0 1px 0 rgba(255,255,255,.7)}
.chip-blue{background:var(--chip-blue)!important}
.chip-green{background:var(--chip-green)!important}
.chip-red{background:var(--chip-red)!important}
.chip-pink{background:var(--chip-pink)!important}
.chip-amber{background:var(--chip-amber)!important}
.dot{width:6px;height:6px;border-radius:50%;background:#3a4a5f;display:inline-block;margin-right:6px}

.dropdowns {
  padding-top: 0px !important; 
  margin-top: 0px !important;
}

.dropdowns >>> .v-input__control>.v-input__slot:before {
    border-width: 0 !important;
}

.dropdowns >>> .v-input__control>.v-input__slot {
    padding: 0 12px !important;
}

footer.v-footer.theme--light {
  background-color: #fff !important;
}

.w-search >>> .v-input__append-outer {
  align-items: center;
  height: 34px;
}

@media (max-width:1100px){.w-search{min-width:260px;flex:2 1 320px}.w-sm{width:110px}.w-md{width:140px}}

.expand-th {
  width: 25%;
  height: 20px;
  text-align: left;
  vertical-align: top;
}
.notes-th {
  height: 20px;
  text-align: left;
  vertical-align: top;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  line-height: 1;
  font-size: 12px;
}

.table-striped tbody > tr:nth-of-type(2n) {
  background-color: #fff;
}
</style>
